import AdminSettings from '../components/admin/AdminSettings';

export default function AdminSettingsPage() {
  return <AdminSettings />;
}
